import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import BookingModal from "@/components/BookingModal";
import ScrollReveal from "@/components/ScrollReveal";

const CalculatorCTA = () => {
  const { t } = useTranslation();
  const [bookingModalOpen, setBookingModalOpen] = useState(false);

  return (
    <>
      <ScrollReveal delay={0.3}>
        <div className="bg-card rounded-lg border border-border p-8 text-center space-y-4">
          <p className="text-lg text-foreground font-medium">
            {t("corporateCalculator.cta.question")}
          </p>
          <Button
            size="lg"
            onClick={() => setBookingModalOpen(true)}
            className="px-8"
          >
            {t("corporateCalculator.cta.button")}
          </Button>
        </div>
      </ScrollReveal>

      <BookingModal
        open={bookingModalOpen}
        onOpenChange={setBookingModalOpen}
      />
    </>
  );
};

export default CalculatorCTA;
